<p-dropdown
    [options]="languageList || []"
    [(ngModel)]="selectedLanguage"
    (onChange)="onLanguageChange($event.value)"
    optionLabel="languageName"
    styleClass="mx-2 p-0 height-36 line-height-1"
    placeholder="Select Language"
></p-dropdown>
